import QuestionBloc from './question-bloc';

export default QuestionBloc;
